<template>

  <!--  <div class="contactUs">-->
  <!--    <div class="foot" style="color: black; font-size: large">-->
  <!--      <h3>{{ $t('footer.account_desc') }}</h3>-->
  <!--    </div>-->
  <!--    <a href="#" style="font-size: medium">{{ $t('footer.connect_desc') }}</a>-->
  <!--  </div>-->

  <footer>
    <div class="main">
      <div class="footer_nav">
        <ol>
          <li>
            <div class="tit">{{ $t('footer.solutions') }}</div>
          </li>
          <li>
            <router-link to="/solutions/global-collection">{{ $t('footer.solutions_acquiring') }}</router-link>
          </li>
          <li>
            <router-link to="/solutions/payments">{{ $t('footer.solutions_payments') }}</router-link>
          </li>
          <li>
            <router-link to="/solutions/platform">{{ $t('footer.solutions_platform') }}</router-link>
          </li>
          <li>
            <router-link to="/solutions/access">{{ $t('footer.solutions_access') }}</router-link>
          </li>
        </ol>
        <ol>
          <li>
            <div class="tit">{{ $t('footer.resources') }}</div>
          </li>
          <li>
            <router-link to="/resource/AcquisitionDoc">{{ $t('footer.resources_deposit') }}</router-link>
          </li>
          <li>
            <router-link to="/resource/PaymentDoc">{{ $t('footer.resources_withdraw') }}</router-link>
          </li>
          <li>
            <router-link to="/resource/SubscriptionDoc">{{ $t('footer.resources_subscription') }}</router-link>
          </li>
        </ol>
        <ol>
          <li>
            <div class="tit">{{ $t('footer.aboutUs') }}</div>
          </li>
          <li>
            <router-link to="/about/aboutus">{{ $t('footer.aboutUs_company') }}</router-link>
          </li>
          <li>
            <router-link to="/about/policy">{{ $t('footer.aboutUs_terms') }}</router-link>
          </li>
          <li>
            <router-link to="/about/contactus">{{ $t('footer.aboutUs_join') }}</router-link>
          </li>
        </ol>
      </div>
      <div class="copy_text">
        <p>{{ $t('footer.copyright') }}&nbsp;&nbsp;&nbsp;©2022-2025  UnionWallex Limited All Rights Reserved</p>
      </div>
    </div>
  </footer>

</template>
<script setup>

</script>
<style scoped>

</style>
